/* MysticDealz : outil Analyser mon eau (donnees publiques Hub'Eau + API Geo) */
(function () {
  if (window.customElements.get('eau-analyse')) return;

  var HUB = 'https://hubeau.eaufrance.fr/api/v1/qualite_eau_potable/resultats_dis';
  var GEO = 'https://geo.api.gouv.fr/communes';
  var FIELDS = 'code_parametre,resultat_alphanumerique,libelle_unite,limite_qualite_parametre,date_prelevement,conclusion_conformite_prelevement,nom_distributeur';
  var STORE = 'eau-commune';
  var NM = 'Non mesurable';

  var PARAMS = [
    { id: 'nitrates', codes: ['1340'], label: 'Nitrates', why: 'Viennent surtout des engrais agricoles.', filtre: 'Les carafes et filtres à charbon ne les retiennent pas. Un osmoseur les réduit fortement.' },
    { id: 'pesticides', codes: ['6276'], label: 'Pesticides (total)', why: 'Somme des pesticides recherchés. Limite : 0,1 µg/L par substance et 0,5 µg/L au total.', filtre: 'Le charbon actif en réduit certains, selon le modèle. Seul le test d’un modèle précis le prouve.' },
    { id: 'pfas', codes: ['8847'], label: 'PFAS (somme de 20)', why: 'Les « polluants éternels », venus de l’industrie et de certains objets du quotidien.', filtre: 'Certains filtres à charbon et osmoseurs les réduisent, s’ils ont été testés pour cela.' },
    { id: 'durete', codes: ['7972', '1345'], label: 'Calcaire (dureté)', why: 'Calcium et magnésium dissous. Sans risque pour la santé.', filtre: 'Une cartouche avec résine anti-calcaire en retire une partie. Un osmoseur en retire presque tout.' },
    { id: 'chlore', codes: ['1398'], label: 'Chlore libre', why: 'Ajouté pour garder l’eau propre jusqu’au robinet. C’est souvent lui qu’on sent au goût.', filtre: 'Le charbon actif (carafe, filtre sur robinet) réduit en général son goût et son odeur.' },
    { id: 'plomb', codes: ['1382'], label: 'Plomb', why: 'Vient surtout des vieilles canalisations.', filtre: 'Seuls les filtres testés pour le plomb (norme NSF/ANSI 53 par exemple) le réduisent de façon prouvée.' },
    { id: 'ecoli', codes: ['1449'], label: 'Bactéries E. coli', why: 'Signe d’une contamination de l’eau.', filtre: 'Les filtres de la maison ne sont pas faits pour désinfecter l’eau.', below: 'Non détectées', limitText: 'Aucune tolérée' }
  ];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function frDate(s) {
    var d = new Date(s);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  }
  function minDate() {
    var d = new Date();
    d.setFullYear(d.getFullYear() - 3);
    return d.toISOString().slice(0, 10);
  }
  function num(v) {
    return parseFloat(String(v == null ? '' : v).replace(/[<>\s]/g, '').replace(',', '.'));
  }
  function fmt(v) {
    v = String(v == null ? '' : v).trim();
    var lt = v.charAt(0) === '<';
    var n = v.replace(/^[<>]\s*/, '');
    if (!/^[\d.,]+$/.test(n)) return lt ? NM : v;
    if (/^\d+,\d+$/.test(n)) n = n.replace(/0+$/, '').replace(/,$/, '');
    return (lt ? '< ' : '') + n;
  }
  function unit(u) {
    if (!u || u === 'SANS OBJET') return '';
    if (u.indexOf('100mL') > -1 || u.indexOf('100 mL') > -1) return 'pour 100 mL';
    return u.replace('mg(Cl2)/L', 'mg/L');
  }
  function limitTxt(p, l) {
    if (p.limitText) return p.limitText;
    if (!l) return 'Aucune';
    var m = String(l).match(/<=?\s*([\d,]+)\s*(.*)$/);
    return m ? m[1] + ' ' + unit(m[2].trim()) : l;
  }
  function hardness(v) {
    if (v < 10) return 'Eau très douce';
    if (v < 20) return 'Eau douce';
    if (v < 30) return 'Moyennement calcaire';
    return 'Calcaire';
  }
  function state(p, r) {
    var raw = String(r.resultat_alphanumerique || '').trim();
    var v = num(raw);
    if (raw.charAt(0) === '<' || (p.below && v === 0)) return { cls: 'ok', txt: p.below || 'Trop faible pour être mesuré' };
    if (p.id === 'durete' && !isNaN(v)) return { cls: 'info', txt: hardness(v) };
    var m = String(r.limite_qualite_parametre || '').match(/<=?\s*([\d,]+)/);
    if (m && !isNaN(v)) return v > num(m[1]) ? { cls: 'alert', txt: 'Au-dessus de la limite' } : { cls: 'ok', txt: 'Sous la limite' };
    return { cls: 'info', txt: 'Pas de limite réglementaire' };
  }
  function getFirst(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    }).then(function (j) {
      return j && j.data && j.data.length ? j.data[0] : null;
    });
  }
  /* « Paris 11e » ou « Paris 11 » : on cherche par arrondissement (code postal 750xx) */
  function normalize(q) {
    var m = String(q || '').trim().match(/^(paris|lyon|marseille)\s*(\d{1,2})\s*(?:e|er|ème|eme)?$/i);
    if (!m) return q;
    var n = parseInt(m[2], 10);
    if (isNaN(n) || n < 1 || n > 20) return q;
    var city = m[1].toLowerCase();
    var prefix = city === 'paris' ? '750' : city === 'lyon' ? '690' : '130';
    return prefix + (n < 10 ? '0' + n : String(n));
  }

  class EauAnalyse extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.form = this.querySelector('form');
      this.input = this.querySelector('.eau-input');
      this.list = this.querySelector('.eau-suggestions');
      this.live = this.querySelector('[data-live]');
      this.result = this.querySelector('.eau-result');
      this.savedBox = this.querySelector('.eau-saved');
      this.sseq = 0;
      this.rseq = 0;
      this.timer = null;
      this.input.addEventListener('input', function () {
        clearTimeout(self.timer);
        var q = self.input.value.trim();
        self.timer = setTimeout(function () { self.suggest(normalize(q), false); }, 250);
      });
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        var first = self.list.querySelector('button[data-code]');
        if (first) first.click();
        else self.suggest(normalize(self.input.value.trim()), true);
      });
      this.list.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-code]');
        if (b) self.choose({ code: b.dataset.code, nom: b.dataset.nom, dep: b.dataset.dep });
      });
      /* Recherche lancée depuis un autre bloc de la page (en-tête) */
      document.addEventListener('eau:search', function (e) {
        var q = e.detail && e.detail.q ? String(e.detail.q).trim() : '';
        if (!q) return;
        self.input.value = q;
        try { self.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { self.scrollIntoView(); }
        self.suggest(normalize(q), true);
      });
      this.showSaved();
      /* Recherche arrivée par l'adresse : /pages/analyser-mon-eau?commune=… */
      try {
        var pq = new URLSearchParams(window.location.search).get('commune');
        if (pq && pq.trim()) {
          this.input.value = pq.trim();
          this.suggest(normalize(pq.trim()), true);
        }
      } catch (err) { /* navigateur ancien : on ignore */ }
    }

    say(t) { if (this.live) this.live.textContent = t; }

    suggest(q, auto) {
      var self = this;
      var id = ++this.sseq;
      if (q.length < 2) { this.renderList([]); return; }
      var url = /^\d{5}$/.test(q)
        ? GEO + '?codePostal=' + q + '&fields=nom,code,codesPostaux,departement&limit=10'
        : GEO + '?nom=' + encodeURIComponent(q) + '&fields=nom,code,codesPostaux,departement&boost=population&limit=6';
      fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function (data) {
        if (id !== self.sseq) return;
        var items = data.map(function (c) {
          return { code: c.code, nom: c.nom, dep: c.departement ? c.departement.nom + ' (' + c.departement.code + ')' : '', cp: c.codesPostaux && c.codesPostaux.length ? c.codesPostaux[0] : '' };
        });
        if (auto && items.length === 1) { self.choose(items[0]); return; }
        /* Nom exact (ex : « Paris ») : on choisit directement la commune la plus peuplée */
        if (auto && items.length > 1 && items[0].nom.toLowerCase() === String(q).toLowerCase()) { self.choose(items[0]); return; }
        self.renderList(items);
        if (!items.length) self.say('Aucune commune trouvée. Vérifiez l’orthographe ou essayez le code postal.');
      }).catch(function () {
        if (id === self.sseq) self.say('La recherche de communes ne répond pas. Réessayez dans un instant.');
      });
    }

    renderList(items) {
      this.list.innerHTML = items.map(function (i) {
        return '<li><button type="button" data-code="' + esc(i.code) + '" data-nom="' + esc(i.nom) + '" data-dep="' + esc(i.dep) + '"><span>' + esc(i.nom) + '</span><small>' + esc(i.dep) + (i.cp ? ' · ' + esc(i.cp) : '') + '</small></button></li>';
      }).join('');
      this.list.hidden = !items.length;
      if (items.length) this.say(items.length > 1 ? items.length + ' communes proposées.' : '1 commune proposée.');
    }

    choose(c) {
      var self = this;
      clearTimeout(this.timer);
      this.sseq++;
      this.input.value = c.nom;
      this.renderList([]);
      this.save(c);
      var id = ++this.rseq;
      this.result.hidden = false;
      this.result.setAttribute('aria-busy', 'true');
      this.result.innerHTML = '<p class="eau-hint">Chargement des dernières analyses pour ' + esc(c.nom) + '…</p>';
      this.say('Recherche des analyses pour ' + c.nom + '.');
      var base = HUB + '?code_commune=' + encodeURIComponent(c.code) + '&size=1&sort=desc&date_min_prelevement=' + minDate() + '&fields=' + FIELDS;
      var calls = PARAMS.map(function (p) { return getFirst(base + '&code_parametre=' + p.codes.join(',')); });
      calls.push(getFirst(base));
      Promise.allSettled(calls).then(function (out) {
        if (id !== self.rseq) return;
        self.render(c, out);
        self.result.removeAttribute('aria-busy');
      });
    }

    render(c, out) {
      var last = out[out.length - 1];
      var failed = out.every(function (o) { return o.status === 'rejected'; });
      if (failed) {
        this.result.innerHTML = '<p>Le service public de données sur l’eau ne répond pas pour le moment. Réessayez dans quelques minutes.</p>';
        this.say('Le service ne répond pas.');
        return;
      }
      var latest = last.status === 'fulfilled' ? last.value : null;
      if (!latest) {
        this.result.innerHTML = '<h3 class="eau-result__place">' + esc(c.nom) + '</h3><p>Aucune analyse publiée ces trois dernières années pour cette commune. Votre mairie ou votre distributeur d’eau peut vous transmettre les résultats.</p>';
        this.say('Aucune analyse trouvée pour ' + c.nom + '.');
        return;
      }
      var rows = PARAMS.map(function (p, i) { return { p: p, r: out[i].status === 'fulfilled' ? out[i].value : null }; });
      var h = '<h3 class="eau-result__place">' + esc(c.nom) + '</h3>';
      h += '<p class="eau-result__meta">' + (c.dep ? esc(c.dep) + ' · ' : '') + 'Eau distribuée par ' + esc(latest.nom_distributeur || 'un distributeur non précisé') + ' · Dernier prélèvement publié : ' + esc(frDate(latest.date_prelevement)) + '</p>';
      var concl = latest.conclusion_conformite_prelevement;
      if (concl) {
        h += '<div class="eau-verdict"><p class="eau-verdict__label">Conclusion officielle de ce prélèvement</p><p>' + esc(concl) + '</p>';
        if (/r[ée]f[ée]rences de qualit/i.test(concl)) {
          h += '<p class="eau-source">Les « références de qualité » sont des repères de goût, d’aspect et de bon fonctionnement du réseau. Les « limites de qualité » concernent la santé.</p>';
        }
        h += '</div>';
      }
      h += '<div class="eau-table-wrap"><table class="eau-table eau-table--stack"><caption class="visually-hidden">Derniers résultats publiés pour ' + esc(c.nom) + '</caption><thead><tr><th scope="col">Ce qu’on mesure</th><th scope="col">Dernier résultat</th><th scope="col">Limite de qualité</th><th scope="col">État</th><th scope="col">Ce qu’un filtre peut y faire</th></tr></thead><tbody>';
      rows.forEach(function (x) {
        var head = '<th scope="row">' + esc(x.p.label) + '<small>' + esc(x.p.why) + '</small></th>';
        if (!x.r) {
          h += '<tr>' + head + '<td data-label="Dernier résultat" colspan="3"><span class="eau-empty">Pas de mesure publiée depuis trois ans</span></td><td data-label="Ce qu’un filtre peut y faire">' + esc(x.p.filtre) + '</td></tr>';
          return;
        }
        x.st = state(x.p, x.r);
        var shown = fmt(x.r.resultat_alphanumerique);
        var u = shown === NM ? '' : unit(x.r.libelle_unite);
        h += '<tr>' + head +
          '<td data-label="Dernier résultat"><span class="eau-val">' + esc(shown) + '</span> <span class="eau-unit">' + esc(u) + '</span><small>' + esc(frDate(x.r.date_prelevement)) + '</small></td>' +
          '<td data-label="Limite de qualité">' + esc(limitTxt(x.p, x.r.limite_qualite_parametre)) + '</td>' +
          '<td data-label="État"><span class="eau-status eau-status--' + x.st.cls + '">' + esc(x.st.txt) + '</span></td>' +
          '<td data-label="Ce qu’un filtre peut y faire">' + esc(x.p.filtre) + '</td></tr>';
      });
      h += '</tbody></table></div>';
      h += this.advice(rows);
      h += '<p class="eau-source">Source : contrôle sanitaire de l’eau potable (ministère chargé de la Santé et agences régionales de santé), données publiques diffusées par Hub’Eau et mises à jour chaque mois. Ces mesures portent sur le réseau public, pas sur les tuyaux de votre logement. Il n’existe pas de limite réglementaire pour le calcaire : les classes affichées reprennent les repères de l’agence régionale de santé des Pays de la Loire.</p>';
      if (this.dataset.lien) h += '<p class="eau-more"><a class="eau-link" href="' + esc(this.dataset.lien) + '">' + esc(this.dataset.lienLabel || 'Voir les filtres') + '</a></p>';
      this.result.innerHTML = h;
      this.say('Résultats affichés pour ' + c.nom + '.');
    }

    advice(rows) {
      var get = function (id) { return rows.filter(function (x) { return x.p.id === id; })[0]; };
      var tips = [];
      var over = rows.filter(function (x) { return x.st && x.st.cls === 'alert'; });
      if (over.length) {
        tips.push('Au moins un résultat dépasse une limite de qualité : ' + over.map(function (x) { return x.p.label; }).join(', ') + '. Dans ce cas, la mairie et l’agence régionale de santé informent les habitants et donnent des consignes. Suivez-les en priorité : un filtre ne les remplace pas.');
        if (over.some(function (x) { return x.p.id === 'nitrates'; })) tips.push('Pour les nitrates, seul un osmoseur (ou une résine spéciale) les réduit vraiment.');
      } else {
        tips.push('Pour les mesures ci-dessus, les derniers résultats respectent les limites de qualité. Un filtre n’est pas nécessaire pour votre santé. Il peut améliorer le goût ou réduire le calcaire.');
      }
      var d = get('durete');
      if (d && d.r) {
        var v = num(d.r.resultat_alphanumerique);
        if (!isNaN(v) && v >= 20) tips.push('Votre eau est ' + (v >= 30 ? 'calcaire' : 'moyennement calcaire') + ' (' + fmt(d.r.resultat_alphanumerique) + ' °f). Pour l’eau que vous buvez, une carafe avec cartouche anti-calcaire en retire une partie. Pour la douche, les filtres courants agissent surtout sur le chlore, très peu sur le calcaire.');
      }
      var cl = get('chlore');
      if (cl && cl.r) {
        var k = num(cl.r.resultat_alphanumerique);
        if (!isNaN(k) && k >= 0.1) tips.push('Du chlore est présent (' + fmt(cl.r.resultat_alphanumerique) + ' mg/L). Un filtre à charbon actif, en carafe ou sur le robinet, réduit en général son goût.');
      }
      tips.push('Si votre immeuble date d’avant 1950, le plomb peut venir des canalisations intérieures, que ces analyses ne couvrent pas. Un filtre testé pour le plomb, ou une analyse de l’eau de votre robinet par un laboratoire agréé, lève le doute.');
      return '<div class="eau-advice"><h3 class="h3">Ce que ça veut dire pour vous</h3><ul>' + tips.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul></div>';
    }

    save(c) {
      try { window.localStorage.setItem(STORE, JSON.stringify(c)); } catch (e) { return; }
    }

    showSaved() {
      var self = this;
      var c = null;
      try { c = JSON.parse(window.localStorage.getItem(STORE) || 'null'); } catch (e) { c = null; }
      if (!c || !c.code || !this.savedBox) return;
      this.savedBox.innerHTML = 'Dernière recherche : <button type="button" data-saved>' + esc(c.nom) + '</button> <button type="button" class="eau-saved__forget" data-forget aria-label="Oublier la dernière recherche">Oublier</button>';
      this.savedBox.hidden = false;
      this.savedBox.querySelector('[data-saved]').addEventListener('click', function () { self.choose(c); });
      this.savedBox.querySelector('[data-forget]').addEventListener('click', function () {
        try { window.localStorage.removeItem(STORE); } catch (e) { /* rien */ }
        self.savedBox.hidden = true;
        self.savedBox.innerHTML = '';
        self.say('Dernière recherche oubliée.');
      });
    }
  }

  window.customElements.define('eau-analyse', EauAnalyse);
})();
